'use strict';

const react = require('@emotion/react');
const React = require('react');
const theme_Colors = require('../../../theme/Colors.cjs.js');
require('../../../theme/Shadows.cjs.js');
require('../../../theme/Typography.cjs.js');
const components_display_Icon_Icon = require('../../display/Icon/Icon.cjs.js');
const components_display_Text_Text = require('../../display/Text/Text.cjs.js');
const components_display_TooltipWrapper_TooltipWrapper = require('../../display/TooltipWrapper/TooltipWrapper.cjs.js');
const components_navigation_PageNavigation_PageNavigationBadge = require('./PageNavigationBadge.cjs.js');
const components_navigation_PageNavigation_PageNavigationRow = require('./PageNavigationRow.cjs.js');
const components_navigation_PageNavigation_utils_checkIsTruncated = require('./utils/checkIsTruncated.cjs.js');

const Styles = {
  // The width value for textContainer is 90% of the row width, less the
  // width of the space available for the Badge count (32px).
  textContainer: (showCount) => [
    react.css`
      align-items: center;
      display: flex;
      flex-direction: row;
      position: relative;
      width: calc(90% - var(--zds-size-32));
    `,
    showCount === false && react.css`
        width: 100%;
      `
  ],
  textEllipsis: (textColor) => react.css`
    color: ${theme_Colors.Colors[textColor]};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  rowContainer: (_hover, _selected) => [
    react.css`
      border-radius: var(--zds-radius-small);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: var(--zds-space-8) var(--zds-space-20);
    `
  ],
  rowWrapper: (_hover, selected) => [
    selected && react.css`
        border-radius: var(--zds-radius-small);
        background-color: ${theme_Colors.Colors.UiPrimaryWeakest};
      `
  ]
};
function NonNestedRow({ item, onSelect, showCount }) {
  const [isTruncated, setIsTruncated] = React.useState(false);
  const textRef = React.useRef(null);
  React.useEffect(() => {
    setIsTruncated(components_navigation_PageNavigation_utils_checkIsTruncated(textRef));
  }, []);
  const InnerContent = ({ hover, selected }) => {
    const iconColor = hover || selected ? "UiPrimaryStrongest" : "GrayWarm6";
    const textColor = hover || selected ? "UiPrimaryStrongest" : "GrayWarm10";
    const badgeVariant = hover || selected ? "primary-stronger" : "neutral";
    const textType = selected ? "Body3" : "Body1";
    return react.jsx(
      "div",
      { css: Styles.rowContainer(hover, selected), "data-zds": true },
      react.jsx(
        "span",
        { css: Styles.textContainer(showCount), "data-zds": true },
        item.icon !== null && react.jsx(components_display_Icon_Icon.Icon, { color: iconColor, name: item.icon || "navFolder", size: 24 }),
        react.jsx(
          "span",
          { css: Styles.textEllipsis(textColor), ref: textRef, "data-zds": true },
          react.jsx(components_display_Text_Text.Text, { color: textColor, margin: "0 0 0 8px", type: textType }, item.title)
        )
      ),
      item.count ? react.jsx(components_navigation_PageNavigation_PageNavigationBadge, { variant: badgeVariant }, item.count.toString()) : null
    );
  };
  const Content = ({ hover, selected }) => {
    const innerContent = isTruncated ? react.jsx(components_display_TooltipWrapper_TooltipWrapper.TooltipWrapper, { allowMultilineTooltip: true, content: item.title, isBlock: true, position: "northeast" }, () => react.jsx(InnerContent, { hover, selected })) : react.jsx(InnerContent, { hover, selected });
    return react.jsx("div", { css: Styles.rowWrapper(hover, selected), "data-zds": true }, innerContent);
  };
  return react.jsx(components_navigation_PageNavigation_PageNavigationRow, { content: Content, item, onSelect });
}

module.exports = NonNestedRow;
//# sourceMappingURL=NonNestedRow.cjs.js.map
